module.exports = __webpack_public_path__ + "media/images/tiktok-72b5c7a395da44769eb640c93bef4a81.svg";